import { getQueryParameter } from "./getQueryParameter";

export function isLoadedInIframe() {
    const isLoadedInIframe = getQueryParameter(window.location.href,'isLoadedInIframe') == 'true';
    try {
        return isLoadedInIframe || window.self !== window.top;
    } catch (e) {
        return true;
    }
}
